import { PricingSection } from "@/components/Pricing";

const Princing = () => {
  return <PricingSection></PricingSection>;
};

export default Princing;
